import React, { Fragment, useState } from 'react';
import { connect } from 'react-redux';
import { useDispatch } from 'react-redux';
import styles from '../../styles/modules/components/SelfServe/child-page.module.scss';
import { OpenRequestAlert } from '../../components/selfserve/OpenRequestModal';
import { GetPlanDetails, GetPlanCovers } from '../../api/selfserve';
import {
    planCoversFetched,
    updateAddressDetails,
    updateAppointmentDate,
    updateDeviceDetails,
    updateSelectedCover,
    updateSelectedPlan,
    updateWhatsappCheck,
    updateCategoryDetails,
    updateIsServicePgChargesApplicable,
} from '../../redux/actions/selfserveActions';
import { GetCategoryDetails } from '../../api/selfserve';


interface HCBChildPlanCard {
    onClick: (e: React.MouseEvent) => void,
    style?: object,
    className?: string | null,
    children?: React.ReactNode,
    disabled?: boolean,
    childPlan: any,
    key: any,
    is_selected: Boolean,

}

interface HCPChildPlanCard {
    onClick: (e: React.MouseEvent) => void,
    style?: object,
    className?: string | null,
    children?: React.ReactNode,
    disabled?: boolean,
    childPlan: any,
    key: any,
    is_selected: Boolean,

}

const ChildPlanList = (props: any) => {

    const dispatch:any = useDispatch();

    const { ticket_list, planDetails, deviceDetails, categoryDetails, current_step } = props.selfserveReducer

    const [isActiveSR, changeIsActiveSR] = useState(false);
    const [activeSRRefNo, setActiveSRRefNo] = useState(planDetails.hasOwnProperty('ref_no') ? planDetails.ref_no : '')
    const [selectedOsid] = useState('')

    // Handles when click on Child Card
    const handleHcpClick = (item) => {
        if (item.id !== planDetails.id) {

            // Enabling & Disabling Next Button
            let btn;
            if (item.reopen_eligible && item.covers > 1) {
                btn = false;
            }
            else if (!['Active', 'Under Brand Warranty'].includes(item.plan_status) || (item.active_sr_exists)) {

                // Disable Button here
                btn = true;

            } else {

                // Enable Button Here
                if (item.reopen_eligible && item.covers === 1) {
                    btn = true
                } else {
                    btn = false;
                }

            }
            // If Clicked Plan is Not already Selected
            props.setPageLoading(true);
            props.setCoversNo(item.covers);
            const data = {
                "token_id": props.selfserveReducer.token_id,
                "osid": item.osid
            }
            GetPlanDetails(item.tokenized_osid, {

                "application": "website",
                "data": JSON.stringify(data)

            }).then((res: any) => {
                const response = res.data;
                const oldData = response.old_data;

                setActiveSRRefNo(response.sr_id)
                response['button_disabled'] = btn;
                props.setDisableBtn(btn);
                dispatch(updateSelectedPlan((response)));
                dispatch(updateDeviceDetails(item,true))
                // Updating address with oldData values if exist
                if (oldData.hasOwnProperty('old_order')) {
                    if (oldData.old_order.address.pincode) {
                        const addressData = {
                            address: { address: oldData.old_order.address.address, address2: oldData.old_order.address.address_line2, pincode: oldData.old_order.address.pincode, city: oldData.old_order.address.city, state: oldData.old_order.address.state }
                        }
                        dispatch(updateAddressDetails(addressData))
                    }
                }

                // Whatsapp Opt in Initial State
                dispatch(updateWhatsappCheck(response.can_opt_in_whatsapp));
                const deviceId = res.data.device_detail ? res.data.device_detail.device_id : true
                if (deviceId) {
                    GetPlanCovers({

                        "application": "website",
                        "data": JSON.stringify(data)

                    }).then((covers: any) => {
                        if (covers) {
                            dispatch(updateIsServicePgChargesApplicable(covers?.data?.is_service_pg_charges_applicable || false))
                            if (covers.data && covers.data.hasOwnProperty(deviceId)) {

                                dispatch(planCoversFetched(covers.data[deviceId]));
                            }
                            if (item.covers === 1) {

                                dispatch(updateSelectedCover({ index: 0, selectedCover: covers.data[deviceId] }));
                            }
                            props.setPageLoading(false);
                        }
                    })
                } else {
                    props.setPageLoading(false);
                }
            })


            // Resetting the Appointment Dates
            const appointmentData = {
                appointment_date_1: null,
                appointment_date_2: null,
                appointment_slot_1: (new Date().getHours() < 14) ? "10AM - 2PM" : "2PM - 6PM",
                appointment_slot_2: (new Date().getHours() < 14) ? "10AM - 2PM" : "2PM - 6PM",
            }
            dispatch(updateAppointmentDate(appointmentData));
                // check this part for deactivate plan scenario
                // Sr reopen case
                if (item.active_sr_exists) {
                    changeIsActiveSR(true);
                    // props.setDisableBtn(true)
                }
        }


    }
    const handleHcbClick = (item) =>{
        dispatch(updateDeviceDetails(item,true))

        // check this part for deactivate plan scenario
        // Sr reopen case
        if (item.reopen_eligible && item.covers === 1) {
            // changeReopenEligibleSR(true)
            //add gtm tracking event
        } else if (item.active_sr_exists) {
                setActiveSRRefNo(item.sr_details.ref_no)
                changeIsActiveSR(true);
                //add gtm tracking event
        }else{
            props.setDisableBtn(false);
        }
        fetchCategoryData(item.category_type)
    }
    const fetchCategoryData = (category_type)=>{

        if(!categoryDetails[category_type]){
            const data = {
                category_types:[category_type],
            }
            GetCategoryDetails({
                "application": "website",
                "data": JSON.stringify(data),
                plan_type:props.selfserveReducer.planDetails.plan_name

            }).then((res: any) => {
                const response = res.data;
                dispatch(updateCategoryDetails(response))
            })
        }
    }
    const {
            parentPlanDetails:
            {
                homecare_device_plan_list: childPlanList,
                hcb_serviced_devices: hcbChildPlanList,
                osid,
            },
            restoreTicketKey,

        } = props.selfserveReducer

    const hcbDisableHandler=(item)=>{
        if(item.active_sr_exists && current_step === 15){
            return true
        }
        return restoreTicketKey !== item.deviceKey ? ticket_list.hasOwnProperty(osid.concat("-",item.deviceKey)) ? ticket_list[osid.concat("-",item.deviceKey)].deviceDetails.device_id ? true : false : false : false
    }
    const hcpDisableHandler = (item)=>{
        if(item.plan_validity.is_valid === false && current_step === 15){
            return true
        }
        return restoreTicketKey !== item.deviceKey ? item.deviceKey && ticket_list.hasOwnProperty(item.osid.concat("-",item.deviceKey)) ? true : false: false
    }
    const deviceKey = deviceDetails.deviceKey
    return (
        <div className={styles.hc_plan} data-is_new_device_info={props.is_new_device_info ? props.is_new_device_info :false}>

            <div className={`${styles.card_holder} ${styles.homecare_child_plan}`}>
                {hcbChildPlanList && hcbChildPlanList.map((item, index) => {
                    return <HCBChildPlanCard
                        childPlan={item}
                        is_selected={item.deviceKey ? deviceKey === item.deviceKey ? true : false : false}
                        disabled={hcbDisableHandler(item)}
                        key={item.device_id}
                        onClick={() => { handleHcbClick(item) }}
                    />
                })
                }
            </div>
            <div className={`${styles.card_holder} ${styles.homecare_child_plan}`}>
                {childPlanList && childPlanList.map((item, index) => {
                    return <HCPChildPlanCard
                        childPlan={item}
                        is_selected={planDetails.id === item.id && !ticket_list.hasOwnProperty(item.osid.concat("-",item.deviceKey)) ? true : false}
                        disabled={hcpDisableHandler(item)}
                        key={item.id}
                        onClick={() => { handleHcpClick(item) }}
                    />
                })
                }
            </div>

            {/* <ReopenRequestAlert is_open={reopenEligibleSR} closeModal={changeReopenEligibleSR}  planDetail={props.selfserveReducer.planDetails} osid={selectedOsid}/> */}

            <OpenRequestAlert is_open={isActiveSR} closeModal={changeIsActiveSR} refNo={activeSRRefNo} planDetail={props.selfserveReducer.planDetails} osid={selectedOsid} setPageLoading={props.setPageLoading} category={props.selfserveReducer.deviceDetails?.category}/>
        </div>
    )
}
const HCBChildPlanCard = (props: HCBChildPlanCard) => {
    const childPlan = props.childPlan;
    const { is_selected, disabled } = props
    return (
        <Fragment>
            <div
                className={styles.child_app_btn}
                data-selected={is_selected ? is_selected : false}
                data-disabled={disabled}
                onClick={(e) => {
                    e.preventDefault();
                    props.onClick(e)
                }}
            >
              <div className={`${styles.child_plan_header}`}>
                <p className={styles.plan_header}>
                  {
                    childPlan.brand
                    ? childPlan.brand + " " + childPlan.category_type
                    : childPlan.category_type
                  }
                </p>
              </div>
              <div className={`${styles.child_plan_content}`}>
              {childPlan.category !== childPlan.category_type &&
                <p className={styles.plan_child_type}>{childPlan.category} {childPlan.device_name && "("+childPlan.device_name+")"} </p>
              }
              </div>
              <div className={`${styles.child_plan_content}`}>
              {childPlan.brand &&
                <p className={styles.plan_child_type}>Brand: {childPlan.brand} </p>
              }
              </div>
                {childPlan.active_sr_exists &&
                    <p className={styles.plan_child_error}><div>There is already SR Open {childPlan.sr_details?.ref_no}</div></p>
                }
            </div>
        </Fragment>
    );
};


const HCPChildPlanCard = (props: HCPChildPlanCard) => {
    const childPlan = props.childPlan;
    const { is_selected, disabled } = props
    return (
        <Fragment>
            <div
                className={styles.child_app_btn}
                data-selected={is_selected ? is_selected : false}
                data-disabled={disabled}
                onClick={(e) => {
                    e.preventDefault();
                    props.onClick(e)
                }}
            >
                <p className={styles.plan_child_header}>
                    Services Remaining :{" "}
                    <span className={styles.bold_front}>
                        {childPlan.consume_covers} of {childPlan.covers}
                        {childPlan.service_remaining}
                      <span className={`${styles.plan_status} ${childPlan.plan_status.toLowerCase() == "active" ? styles.plan_status__success : styles.plan_status__fail}`}>
                        {childPlan.plan_status}
                      </span>
                    </span>
                </p>
                <hr />
                <p className={styles.plan_header}>
                    {" "}
                    {childPlan.brand
                        ? childPlan.brand + " " + childPlan.category_type
                        : childPlan.category_type}{" "}
                </p>
                <p className={styles.plan_child_type}>
                  {childPlan.category !== childPlan.category_type ? childPlan.category : ''}
                </p>
                {childPlan.plan_validity.error_message &&
                    <p className={styles.plan_child_error}><div> {childPlan.plan_validity.error_message.map((error,index)=> <div key={index}>{error}</div>)}</div></p>
                }
            </div>
        </Fragment>
    );
};

const mapStateToProps = (state: any) => {
    return {
        selfserveReducer: state.selfserveReducer,
    }
}

export default connect(mapStateToProps)(ChildPlanList);
